<template>
  <a-modal
    title="问答"
    :width="800"
    :visible="visible"
    :ok-button-props="{ props: { disabled: true } }"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"   >
      <div>
          <div class="chat-history">
            <div v-for="(message, index) in messages" :key="index" :class="{ user: message.isUser, bot: !message.isUser }">
              <span>{{ message.text }}</span>
            </div>
          </div>
          <form @submit.prevent="sendMessage">
            <input type="text" v-model="userInput" placeholder="输入您的问题" required style="width:94%;"/>
            <button style="color: white;background-color: #3260c9;" type="submit">发送</button>
          </form>
      </div>
  </a-modal>
</template>

<script>
import axios from 'axios';
import { httpAction} from '@/api/manage'

export default {
  name: "QandA",
  data() {
    return {
      model:{
      },
      visible: false,
      question: '',
      answer: null,
      userInput: '',
      messages: [
        { text: '你好！有什么可以帮助你的？', isUser: false },
      ],
    };
  },
  methods: {
    qanda(){
      this.visible = true;
    },
    async askQuestion() {
      try {
        //const response = await axios.post('/hhemp/aicsp/empaicsplog', {apiType:'chatWithKnowledge',category:'hhemp',lang:'tw',convertTextToSpeech:'0', content: this.question });
        httpAction('/hhemp/aicsp/empaicsplog',{apiType:'chatWithKnowledge',category:'hhemp',lang:'tw',convertTextToSpeech:'0', content: this.question },'post').then((res)=>{
          if(res.success){
            this.answer = JSON.parse(res.result.responseResult).content;
          }else{
            this.$message.warning(res.message);
          }
        }
        )

      } catch (error) {
        console.error('Error fetching answer:', error);
      }
    },
    close () {
      this.$emit('close');
      this.visible = false;
      this.userInput = '';
      this.messages = [
        { text: '你好！有什么可以帮助你的？', isUser: false },
        ];
    },
    handleCancel () {
      this.close()
    },
    handleOk () {
      this.close()
    },
    sendMessage() {
      // 将用户的消息添加到消息列表
      this.messages.push({ text: this.userInput, isUser: true });

      // 清除输入框
      this.userInput = '';

      // 发送用户的输入到后端API
      this.sendToApi(this.messages[this.messages.length - 1].text);
    },
    async sendToApi(userMessage) {
      try {
        // 假设我们有一个后端 API 可以处理这个请求
        //const response = await axios.post('/api/chatbot', { message: userMessage });
        httpAction('/hhemp/aicsp/empaicsplog',{apiType:'cspChatWithKnowledge',category:'hhemp',lang:'tw',convertTextToSpeech:'0', content: userMessage },'post').then((res)=>{
          if(res.success){
            const botResponse = JSON.parse(res.result.responseResult).content;
            // 将机器人的回答添加到消息列表
            this.messages.push({ text: botResponse, isUser: false });
          }else{
            this.$message.warning(res.message);
          }
        })

      } catch (error) {
        console.error('Error fetching answer:', error);
      }
    },
  },
};
</script>

<style scoped>
  .chat-history {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 10px;
  }

  .user {
    float: right;
    background-color: #f0f0f0;
    border-radius: 5px;
    padding: 5px;
    clear: both;
  }

  .bot {
    float: left;
    background-color: #e0f0ff;
    border-radius: 5px;
    padding: 5px;
    clear: both;
  }
</style>